import { useTranslator } from "@eo-locale/react";
import { FiFilter } from "react-icons/fi";

import { IconButton, useBreakpointValue } from "@/storybook-components";
interface IFilterButton {
  handleFilterClick: () => void;
}

const FilterButton = ({ handleFilterClick }: IFilterButton) => {
  const { translate } = useTranslator();
  const responsiveSize = useBreakpointValue(
    { base: "lg", lg: "md" },
    { ssr: false }
  );
  return (
    <IconButton
      size={responsiveSize}
      boxShadow={responsiveSize}
      _hover={{ background: "gray.100", color: "gray.900" }}
      variant="solid"
      borderRadius="50%"
      bgColor="white"
      color="gray.900"
      onClick={handleFilterClick}
      icon={<FiFilter />}
      aria-label={translate("places.pin.label")}
    />
  );
};

export default FilterButton;
